const state = {
    count: 0,
    detailsData: {},
    detailsID: 0, // 详情页ID
    appKey: "",
    searchWord: ''
}



export default state